<button type="button"
  class="customHeaderLabel"
  [disabled]="isDisabled"
  [attr.aria-expanded]="!isCollapsed"
  (click)="toggleCollapsed()">
  <esp-icon class="row-expanded" name="minus"></esp-icon>
  <span style="vertical-align: middle" title="{{displayName}}">{{displayName}}</span>
</button>
